function copyToClipboard(element) {
  const input = document.getElementById(element);
  input.select();
  navigator.clipboard.writeText(input.value);
}

export default {
  copyToClipboard,
};
